module.exports = __webpack_public_path__ + "static/media/Fieldtrip-New-York-1.859978b7.jpg";